const state = () => ({
  isLogin: true,
  token: localStorage.getItem('token') || '',
  user: window.localStorage.getItem('auth')
    ? JSON.parse(window.localStorage.getItem('auth'))
    : null,
  shop: window.localStorage.getItem('shop')
    ? JSON.parse(window.localStorage.getItem('shop'))
    : null,
  accessToken: window.localStorage.getItem('accessToken')
    ? window.localStorage.getItem('accessToken')
    : null // accessToken
})

const getters = {
  getAccessToken(state) {
    return `Bearer ${state.accessToken}`
  },

  getAuthToken(state) {
    return state.accessToken
  }
}

const mutations = {
  setStatus(state, { token, isLogin }) {
    state.isLogin = isLogin
    state.token = token
  },

  setAuth(state, { user, shop, accessToken }) {
    state.user = user
    state.shop = shop
    state.accessToken = accessToken
  }
}

const actions = {
  initAuth({}, data) {
    return new Promise((resolve, reject) => {
      if (
        data ||
        (localStorage.getItem('token') &&
          new Date().getTime() < +localStorage.getItem('expireTime'))
      ) {
        resolve('Authorization.')
      } else {
        reject('Unauthorization.')
      }
    })
  },

  getLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      if (data) {
        let token = 'token_data'
        localStorage.setItem('token', token)
        localStorage.setItem('expireTime', new Date().getTime() + Number.parseInt(3600) * 1000)
        resolve('success')
        commit('setStatus', { token: token, isLogin: true })
      } else {
        reject('Fail!')
      }
    })
  },

  getLogout({ commit }) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('token')
      commit('setStatus', { token: '', isLogin: false })
      resolve()
    })
  },

  // ==================================================================
  // New Function
  getLoginNew({ commit }, data) {
    return new Promise((resolve, reject) => {
      if (data) {
        const token = data.accessToken

        const authData = {
          id: data.id,
          name: data.name,
          position: data.department,
          profile: data.pic
        }

        const shopData = {
          id: data.shop.id,
          name: data.shop.name
        }

        localStorage.setItem('auth', JSON.stringify(authData))
        localStorage.setItem('shop', JSON.stringify(shopData))
        localStorage.setItem('accessToken', token)

        // parameter old
        localStorage.setItem('token', token)
        localStorage.setItem('expireTime', new Date().getTime() + Number.parseInt(3600) * 1000)

        resolve('success')

        // commit
        commit('setStatus', { token: token, isLogin: true })
        commit('setAuth', { user: authData, shop: shopData, accessToken: token })
      } else {
        reject('Fail!')
      }
    })
  },

  getLogoutNew({ commit }) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('auth')
      localStorage.removeItem('shop')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('token')
      localStorage.removeItem('expireTime')
      commit('setStatus', { token: '', isLogin: false })
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
